import { Outlet, useOutletContext } from "react-router-dom";

/**
 * The layout route around every /home-videos page. It hands the shell's
 * outlet context (`me`, `meLoading`, …) straight through, and wraps the
 * pages in `[data-home-videos]`: inside it the light theme's muted text is
 * a step darker, so the subtitles, the chip legend and the counts read AA
 * on the page background (tailwind.css). The dialogs the pages portal out
 * carry the same attribute themselves.
 *
 * It is a flex column filling <main>, so a page that fills the window
 * (a ready video, from lg: data-fill-viewport) gets the shell's height
 * through it.
 *
 * No humans-only gate here: household agents read and label (D11). The
 * person-only controls gate themselves, failing closed while `me` is
 * unknown.
 */
function HomeVideosLayout() {
  const shell = useOutletContext();
  return (
    <div data-home-videos="" className="flex min-h-0 flex-1 flex-col">
      <Outlet context={shell} />
    </div>
  );
}

export default HomeVideosLayout;
